import API from 'types/api';
import APP from 'types/app';

const initialState = {
  purchaseDataHash: '',
};

export default (state = initialState, { type, payload }) => {
  let newState;
  switch (type) {
    case API.POST_CARD_ENCRYPT_SUCCESS:
      return {
        ...state,
        purchaseDataHash: payload.cyphertext,
      };
    case APP.RESET_SERVICE_API_DATA:
      if (payload === 'billing') {
        newState = {
          ...initialState,
        };
      } else {
        newState = state;
      }
      return newState;
    default:
      return state;
  }
};
